import React, { useEffect, useState } from 'react';
import {Drawer, Table} from 'antd';

import AddLookupDetails from 'modules/lookup_table/add_lookup_values/addLookupDetails';

const columns = [
    {
        title: "POSITION",
        dataIndex: "sort",
        key: "sort",
        width: "5%"
    },
    {
        title: "VAT INPUT NAME",
        dataIndex: "vat_input_name",
        key: "vat_input_name",
        width: "30%"
    },
    {
        title: "DESCRIPTION",
        dataIndex: "vat_input_desc",
        key: "vat_input_desc",
        width: "35%"
    },
    {
        title: "DEFAULT",
        dataIndex: "default",
        key: "default",
        width: "5%"
    },
    {
        title: "DATE CREATED",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "15%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "10%"
    },
];

function SearchVatInputTable(props) {
    const { data, pageSize } = props;
    const [tableData, setTableData] = useState([]);
    const [tableValues, setTableValues] = useState(data);

    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };

    const onClose = () => { 
        setOpen(false); 
        // setTableData([]);
    };

    useEffect(()=> {
        setTableValues(data);
    }, [data])

    function setData(values) {
        setTableValues(values);
    }

    function refreshTblData(values) {
        console.log('check vat refresh', values)
    }

    function updateDrawer(e) {
        setTableData(e)
        showDrawer();
    }

    function drawerClose(value) {
        setOpen(value);
    }

    return(
        <div>
            <Table
                style={ {textTransform: "uppercase"} }
                dataSource = {tableValues}
                columns={columns}
                bordered
                pagination={{ defaultPageSize: 5 }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => {updateDrawer(record)}
                    };
                }}
            />
            <Drawer title={"UPDATE " + props.lookupValue} placement="right" onClose={onClose}
                width="30%"
                visible={open}
            >
                <AddLookupDetails 
                    lookupDet={props.lookupValue} 
                    drawerClose={ drawerClose }
                    refreshTblData={ refreshTblData }
                    tableData={ tableData }
                    setData={ setData }
                />
            </Drawer>
        </div>
    )
}

export default SearchVatInputTable;